<!-- Landscape Word Legend -->
<div class="word-color-legend container-fluid hidden-md-down">
    <div>
    <div class="row word-color-content pt-2 pb-2">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 legend-text">Word Colors</div>
        <div class="col-lg-3"></div>
    </div>
    <div class="row pt-2 pb-2">
        <div class="col-lg-1"></div>
        <div class="col-lg-8">
            <ul>
                <li class="mastered">Mastered</li>
                <li class="needed-help">Needed Help</li>
                <li class="try-again">Try Again</li>
            </ul>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>
</div>

<!-- Portrait Word Legend -->
<div class="word-color-legend container-fluid hidden-lg-up"
     *ngIf="activeModal && !isReading() && !isReadingMyRecording()"
     role="dialog">
    <div class="row word-color-content pt-2 pb-2">
        <div class="col-xs-1"></div>
        <div class="col-xs-8 legend-text">
            <button type="button" class="close"
                    (click)="closeModal()"
                    data-dismiss="modal"
                    aria-label="Close"></button>Word Colors</div>
        <div class="col-xs-1"></div>
    </div>
    <div class="row pt-1 pb-2">
        <div class="col-xs-1"></div>
        <div class="col-xs-10">
            <ul>
                <li class="mastered">Mastered</li>
                <li class="needed-help">Needed Help</li>
                <li class="try-again">Try Again</li>
            </ul>
        </div>
        <div class="col-xs-0"></div>
    </div>
</div>
